import { useState, useEffect } from 'react';
import Card from './Card';
import Button from './Button';

const ErrorDisplay = ({ error, onClose, onRetry }) => {
  const [showDetails, setShowDetails] = useState(false);

  if (!error) return null;

  const getErrorDetails = () => {
    if (!error) return null;

    const details = {
      message: 'Неизвестная ошибка',
      status: null,
      code: null,
      url: null,
      timestamp: new Date().toLocaleTimeString(),
    };

    // Axios error
    if (error.response) {
      details.status = error.response.status;
      details.message = error.response.data?.error || error.response.statusText || 'Ошибка сервера';
      details.url = error.config?.url || error.config?.baseURL;
    } else if (error.request) {
      details.message = 'Не удалось подключиться к серверу';
      details.code = error.code;
      details.url = error.config?.baseURL || error.config?.url;
    } else {
      details.message = error.message || 'Произошла ошибка';
    }

    return details;
  };

  const errorDetails = getErrorDetails();

  const getErrorType = () => {
    if (errorDetails.code === 'ERR_NETWORK' || errorDetails.code === 'ECONNREFUSED') {
      return 'network';
    }
    if (errorDetails.status === 404) {
      return 'notfound';
    }
    if (errorDetails.status >= 500) {
      return 'server';
    }
    return 'general';
  };

  const errorType = getErrorType();

  const getErrorMessage = () => {
    switch (errorType) {
      case 'network':
        return 'Не удалось подключиться к серверу. Проверьте:\n• Сервер запущен\n• Правильный IP адрес\n• Сетевое подключение';
      case 'notfound':
        return 'Ресурс не найден';
      case 'server':
        return 'Ошибка на сервере';
      default:
        return errorDetails.message;
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <Card className="max-w-md w-full">
        <div className="flex justify-between items-start mb-4">
          <h3 className="text-lg font-semibold text-red-600">Ошибка подключения</h3>
          {onClose && (
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600 text-xl"
            >
              ×
            </button>
          )}
        </div>

        <div className="mb-4">
          <p className="text-gray-700 whitespace-pre-line mb-3">
            {getErrorMessage()}
          </p>

          <button
            onClick={() => setShowDetails(!showDetails)}
            className="text-sm text-blue-600 underline mb-2"
          >
            {showDetails ? 'Скрыть' : 'Показать'} детали
          </button>

          {showDetails && (
            <div className="mt-3 p-3 bg-gray-50 rounded text-xs space-y-1">
              <div><strong>Время:</strong> {errorDetails.timestamp}</div>
              {errorDetails.status && (
                <div><strong>Статус:</strong> {errorDetails.status}</div>
              )}
              {errorDetails.code && (
                <div><strong>Код ошибки:</strong> {errorDetails.code}</div>
              )}
              {errorDetails.url && (
                <div><strong>URL:</strong> {errorDetails.url}</div>
              )}
              {error.config?.baseURL && (
                <div><strong>API Base:</strong> {error.config.baseURL}</div>
              )}
              {error.message && (
                <div className="mt-2 text-red-600">
                  <strong>Сообщение:</strong> {error.message}
                </div>
              )}
            </div>
          )}
        </div>

        <div className="flex gap-2">
          {onRetry && (
            <Button
              variant="primary"
              onClick={onRetry}
              className="flex-1"
            >
              Повторить
            </Button>
          )}
          {onClose && (
            <Button
              variant="secondary"
              onClick={onClose}
              className="flex-1"
            >
              Закрыть
            </Button>
          )}
        </div>
      </Card>
    </div>
  );
};

export default ErrorDisplay;

